export const GradientLib = [
  ["#1A1C19", "#B0B58F"],
  ["#0C0504", "#3E170F"],
  ["#A67F51", "#D7B28C"],
  ["#16100B", "#88786F"],
  ["#2E0F0A", "#985D2F"],
  ["#3F1C0C", "#B4927C"],
  ["#685558", "#BABCC0"],
  ["#30261C", "#8A7955"],
  ["#34241C", "#977C6B"],
  ["#382218", "#B58863"],
  ["#444040", "#9F9C9D"],
  ["#251009", "#431D1D"],
  ["#6D3F1F", "#D7B582"],
  ["#928C6A", "#D1C7A1"],
  ["#8F4628", "#C28F7B"],
  ["#762303", "#B7957E"],
  ["#0F0302", "#9F948D"],
  ["#4F4641", "#BF956E"],
  ["#47484A", "#79614F"],
  ["#120F05", "#B79162"],
  ["#744028", "#B8B8C1"],
  ["#181C28", "#C2B2AA"],
  ["#63676C", "#B8B0A3"],
  ["#495042", "#906F58"],
  ["#3C2A1E", "#2A3641"],
  ["#1B2622", "#375D7C"],
  ["#5775AE", "#9A8689"],
  ["#695642", "#C69E7F"],
  ["#1F1808", "#869AAA"],
  ["#13363F", "#668CA0"],
  ["#463B15", "#527D99"],
  ["#9AA4C5", "#C2A285"],
  ["#324135", "#7082A4"],
  ["#3B2D17", "#8C8977"],
  ["#3D3D27", "#92A0A0"],
  ["#1A2C37", "#147A4F"],
  ["#2B302A", "#ACAFB0"],
  ["#381A13", "#4D484B"],
  ["#082E43", "#9E785A"],
  ["#4A4A46", "#AFA077"],
  ["#8D3A0D", "#DCAA63"],
  ["#4B548B", "#9682DB"],
  ["#51464B", "#9C7479"],
  ["#74100A", "#B7AA7B"],
  ["#0F709A", "#DCAA63"],
  ["#2A3C29", "#988BC3"],
  ["#57424C", "#817784"],
  ["#1E2E1B", "#B7AA7B"],
  ["#341507", "#6D5A49"],
  ["#41090A", "#9C7479"],
  ["#2A3C29", "#819A7D"],
  ["#4E1D16", "#D4CCCE"],
  ["#130D0A", "#BEB8B5"],
  ["#A05128", "#E4DBC6"],
  ["#79768B", "#D9814E"],
  ["#1A1D1A", "#434E53"],
  ["#503C22", "#7A7873"],
  ["#132527", "#787567"],
  ["#23140B", "#959289"],
  ["#413729", "#736B55"],
  ["#404134", "#925938"],
  ["#6F462C", "#9B7B68"],
  ["#3C3B39", "#F6CAA5"],
  ["#5F2B23", "#51394A"],
  ["#9A6945", "#F6CAA5"],
  ["#47200C", "#B1653C"],
  ["#988169", "#CB966B"],
  ["#AD7C50", "#F7DAB0"],
  ["#563C2E", "#736B55"],
  ["#2C1911", "#85544A"],
  ["#47371F", "#DEB283"],
  ["#6A7B34", "#8AAE70"],
  ["#617E10", "#C2B7A2"],
  ["#2F1A01", "#AFAF9D"],
  ["#604736", "#C9CCB9"],
  ["#C5A48C", "#D7D6AF"],
  ["#9A7165", "#D2C7C0"],
  ["#513A0E", "#CAC38B"],
  ["#7B7B60", "#DFC3B5"],
  ["#9A623E", "#9AB863"],
  ["#202117", "#777F50"],
  ["#9C9B41", "#C3BEA3"],
  ["#C4976E", "#8BA7A4"],
  ["#2D2A2B", "#A5A382"],
  ["#43221D", "#B57C6A"],
  ["#9C5835", "#BABD89"],
  ["#BABD89", "#C3C7BD"],
  ["#C57D20", "#C09E7F"],
  ["#2E231E", "#3C565F"],
  ["#CF603E", "#D0866A"],
  ["#D37A3B", "#F0C894"],
  ["#ECA536", "#D3A257"],
  ["#83770F", "#DDA51E"],
  ["#9A8942", "#C6D09B"],
  ["#A19049", "#D9C442"],
  ["#762303", "#966A58"],
  ["#28453E", "#77544C"],
  ["#271910", "#AE6949"],
  ["#7B3213", "#B26F31"],
  ["#D17C0C", "#D9814E"],
  ["#627109", "#D6965F"],
  ["#D7711C", "#CD855C"],
  ["#592A08", "#AB5212"],
  ["#762303", "#B46D36"],
  ["#282820", "#846739"],
  ["#241C23", "#867F75"],
  ["#A9640D", "#DBBD71"],
  ["#2C0100", "#60100E"],
  ["#41150C", "#C95114"],
  ["#181C38", "#983722"],
  ["#A65D21", "#DA9B2F"],
  ["#B4703F", "#F8B983"],
];

const nearestColor = require("nearest-color").from(
  GradientLib.map((color) => color[1])
);

export const getNearestGradientColors = (color?: string) => {
  if (!color) {
    return ["#D17C0C", "#D9814E"];
  }

  const foundColor = nearestColor(color);

  return GradientLib.find((color) => color[1] === foundColor);
};
